<script>
import baseList from "@/views/components/base/baseList.vue";
import { Button } from "view-design";

export default {
  extends: baseList,
  props: {
    descr: String,
    typeId: [String, Number],
    deskId: [String, Number],
    assetNum: String
  },
  data() {
    return {
      table: {
        mname: "work",
        key: "id",
        url: {
          list: "/admin/system/work/historyWorkOrderList"
        },
        output: false,
        order: "repairTime",
      },
      query: {
        type: Object,
        default: () => ({})
      },
      filters: [],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "部门",
          key: "department",
          width: 240,
          align: "left",
          render: (h, params) => {
            const text = params.row.department;
            return h('div', {
              style: {
                display: 'inline-block',
                width: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },
              domProps: {
                title: text
              }
            }, text)
          }
        },
        {
          title: "问题描述",
          key: "descr",
          minWidth: 200,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.descr;
            let arr = text.split(']')
            let tempDescr = arr[1]
            return h('div', [
              h('span', {
                style: {
                  display: 'inline-block',
                  width: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                },
                domProps: {
                  title: tempDescr
                }
              }, tempDescr)
            ])
          },
        },
        {
          title: "处理人",
          key: "maintainerName",
          width: 100,
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 130,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              let directives = [{ name: "auth", value: "system/workOrder/info" }];
              return (
                <Button
                  {...{ directives }}
                  size="small"
                  onClick={() => this.toInfo(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                    marginRight: ".3125rem",
                  }}
                >
                  详情
                </Button>
              );
            },
            (vm, h, currentRow, param) => {
              return (
                <Button
                  size="small"
                  onClick={() => this.torebuild(currentRow)}
                  type="default"
                  style={{
                    border: "none",
                    color: "#4991ff",
                  }}
                >
                  重建
                </Button>
              );
            },
          ],
        },
      ],
    };
  },
  created() {
    this.query = {
      descr: this.descr,
      typeId: this.typeId,
      deskId: this.deskId,
      assetNum: this.assetNum
    };

    this.search()
  },
  methods: {
    torebuild(row) {
      this.$Modal.remove();
      this.$emit('rebuild', row);
    },
    toInfo(row) {
      this.$Modal.remove();
      $utils.url.push({
        name: "workOrder_info",
        query: { kv: row.id },
      });
    },
  },
};
</script>
<style scoped></style>
